var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-notification text-right pointer-events-none",staticStyle:{"width":"2rem","height":"2rem"},style:({
    left: _vm.left,
    right: _vm.right,
    top: _vm.top,
    transform: _vm.transform
  })},[_c('img',{staticClass:"w-full h-full",attrs:{"src":require("@/assets/icons/genicon-icons8-alert.svg"),"alt":"ⓘ"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }